import { render, staticRenderFns } from "./AwardScoreEdit.vue?vue&type=template&id=0e8f27fa"
import script from "./AwardScoreEdit.vue?vue&type=script&lang=js"
export * from "./AwardScoreEdit.vue?vue&type=script&lang=js"
import style0 from "./AwardScoreEdit.vue?vue&type=style&index=0&id=0e8f27fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports